import React, { useEffect, useState } from "react";
import { MapLocation } from "@/models/community.model";

type Props = google.maps.MarkerOptions & {
  infoWindow?: google.maps.InfoWindow;
  content?: string;
};

export type MapMarker = MapLocation & {
  icon: string | null;
  name: string;
  address: string | null;
};

const Marker: React.FC<Props> = (options) => {
  const [marker, setMarker] = useState<google.maps.Marker>();

  useEffect(() => {
    if (!marker) {
      setMarker(new google.maps.Marker());
    }

    // remove marker from map on unmount
    return () => {
      if (marker) {
        marker.setMap(null);
      }
    };
  }, [marker]);

  useEffect(() => {
    if (marker) {
      marker.setOptions(options);
    }
  }, [marker, options]);

  // Add infowindow to map marker
  useEffect(() => {
    marker?.addListener("click", () => {
      options?.infoWindow?.setContent(options.content);
      options?.infoWindow?.open({
        anchor: marker,
        map: options.map,
        shouldFocus: false,
      });
    });
  });

  return null;
};

export default Marker;
